import React, {useEffect, useState, useRef} from "react";
import {useHistory, withRouter} from "react-router-dom";
import QnectTextField from "../qnect-ui/qnect-text-field";
import VerificationCodeDialog from "../custom/login/verification-code-dialog";
import TooManyFailedAttemptsDialog from "../custom/login/too-many-failed-attempts-dialog";
import {ReactComponent as Logo} from "../../assets/login/icon_logo.svg";

import {
    _clearToken,
    _generatePortfolioToken,
    _getLang,
    _getShowOtpModal,
    _hideModal,
    _hideSpinner,
    _isNoLogin, _setAdminLogin, _setCpToken,
    _setLang,
    _setOtpToken,
    _setPortfolioToken,
    _setShowOtpModal, _setTimerStarted,
    _showModal,
    _showSpinner,
    _verifyOtpAndGetUserDetail,
    _getSystemAvailable,
    _getIsPvtModeOn,
    _getScheduledMaintenance
} from "../../store/system/service";

import {connect} from "react-redux";
import {
    _getPolicy, _resetPolicy,
    _storePolicy
} from "../../store/policy/service";
import useConfig from "../qnect-ui/qnect-config";
import useLoginStyles, {StyledModalDiv} from "./login-style";
import {_validateForm} from "../../utils/utility";

import QnectButton from "../qnect-ui/qnect-button";
import Hidden from "@material-ui/core/Hidden";
import {
    _getUser,
    _storeUser,
    _checkEmailIfRegistered,
    _resetUser,
    _verifyAdminUserCredentials,
    _getUserDetailsFromToken,
} from "../../store/user/service";
import TagManager from "react-gtm-module";
import FieldWrapper from "../custom/field-wrapper";
import ScheduledMaintenanceBanner from "../custom/scheduled-maintenance-banner";
import SystemUnavailableBanner from "../custom/system-unavailable-banner";


const AdminLogin = (props) => {
    const history = useHistory();
    const cfg = useConfig(props.lang);
    const formId = 'login-form';
    const classes = useLoginStyles(props);
    const ref = useRef(null);

    const [emailAddress, setEmailAddress] = useState("");
    const [adminEmailAddress, setAdminEmailAddress] = useState("");
    const [otpValue, setOtpValue] = useState("");
    const [emailErrorMessage, setEmailErrorMessage] = useState("");
    const [adminEmailErrorMessage, setAdminEmailErrorMessage] = useState("");
    const [otpErrorMessage, setOtpErrorMessage] = useState("");
    const [resendTimer, setResendTimer] = useState(0);
    const [resendTimerIntervalId, setResendTimerIntervalId] = useState(null);

    const [verifyOpen, setVerifyOpen] = useState(false);
    const [failedOpen, setFailedOpen] = useState(false);

    const [password, setPassword] = useState();
    const [passwordErrorMessage, setPasswordErrorMessage] = useState("");

    useEffect(() => {
        props.clearToken();
        props.resetPolicy();
        props.resetUser();

        TagManager.dataLayer({
            dataLayer: {
                event: 'vpageview',
                pageStep: 'login',
                vPath: '/login'
            }
        });
    }, []);



    const resetResendTimer = () => {
        if (resendTimerIntervalId) {
            clearInterval(resendTimerIntervalId);
        }
        // email timer
        setResendTimer(600);
        let setTimerInterval = setInterval(() => {
            setResendTimer((prevTimer) => {
                if (prevTimer > 0) {
                    return prevTimer - 1;
                } else {
                    clearInterval(setTimerInterval);
                    return 0;
                }
            });
        }, 1000);
        setResendTimerIntervalId(setTimerInterval);
    }

    function handleLogin() {
        if (_validateForm(formId)) {
            props.showSpinner();
            setOtpValue("");
            setOtpErrorMessage('');
            setEmailErrorMessage("");
            setPasswordErrorMessage('');
            props.verifyAdminUserCredentials(adminEmailAddress, password, emailAddress).then((response) => {
                if (response.success) {
                    if (!response.lockType) {
                        if (response.isExisting === 'true') {
                            props.setAdminLogin(adminEmailAddress);
                            props.user.email = emailAddress;
                            props.storeUser(props.user);
                            props.setCpToken(response.token);

                            resetResendTimer();
                            setVerifyOpen(true);
                        } else {
                            setAdminEmailErrorMessage(cfg("loginEmailAddress.errorMessages.emailNotFound"));
                            setEmailErrorMessage(cfg("loginEmailAddress.errorMessages.emailNotFound"));
                            setPasswordErrorMessage(cfg("loginPassword.errorMessages.passwordWrong"));
                        }
                        props.hideSpinner();
                    } else {
                        props.showModal({
                            flat: true,
                            content: <StyledModalDiv>
                                <div className="iconDiv">
                                </div>
                                <div className="title">Email Address is Locked</div>
                                <div className="content">Please try again
                                    after {response.lockType === 'otp' ? '10 minutes' : '1 hour'}</div>
                                <div className="buttonDiv">
                                    <QnectButton
                                        field="continue"
                                        onClick={() => {props.hideModal();}}
                                    />
                                </div>
                            </StyledModalDiv>
                        });
                        props.hideSpinner();
                    }
                }
                else {
                    props.hideSpinner();
                    setEmailErrorMessage(cfg('errorMessage.unknownError'));
                    setPasswordErrorMessage(cfg("errorMessage.unknownError"));
                }
            }, (error) => {
                if (error.response.status === 500 || error.response.status === 400 || error.response.status === 404) {
                    setEmailErrorMessage(cfg('errorMessage.serverError'));
                    setPasswordErrorMessage(cfg("errorMessage.serverError"));
                } else {
                    setEmailErrorMessage(error.response.statusText);
                    setPasswordErrorMessage(error.response.statusText);
                }
                props.hideSpinner();
            });
        }
    }

    const handleResend = () => {
        if (resendTimer === 0) {
            props.showSpinner();
            setOtpValue("");
            setOtpErrorMessage('');

            resetResendTimer();
        }
    }

    const handleVerifyOtp = () => {
        props.showSpinner();
        props.verifyOtpAndGetUserDetail(otpValue, props.user.email).then((response) => {
            if (response.success) {
                props.setCpToken(response.token);
                props.setPortfolioToken(response.token);
                props.setTimerStarted(true);
                console.log("redirecting to portfolio");
                history.push('/portfolio');
            } else {
                setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            }
            props.hideSpinner();
        }, (error) => {
            setOtpErrorMessage(cfg("otp.errorMessages.invalidOTP"));
            props.hideSpinner();
        })
    }

    const hasError = !props.systemAvailable;
    const isPvtModeOn = props.isPvtModeOn;
    const[scheduledMaintenance, setScheduledMaintenance] = useState(null);

    useEffect(() => {
        props.getScheduledMaintenance().then(resp => {
            if (Object.keys(resp.data).length) {
                setScheduledMaintenance(resp.data);
            }
        });
    },[]);


    return (
        <>
            <div className={classes.container}>
                { (hasError || isPvtModeOn) && <SystemUnavailableBanner /> }
                { scheduledMaintenance && <ScheduledMaintenanceBanner value={scheduledMaintenance}/>}
                <div className={ classes.bg }>
                    <Hidden mdDown>
                        <div className={ classes.Cbg_img}/>
                    </Hidden>


                    <div className={classes.right_content}>
                        <Hidden smDown>
                            <div className={classes.icon_wrapper}>
                                <a onClick={() => {window.open('https://www.qbe.com/sg/about-qbe', '_blank');}}>
                                    <Logo/>
                                </a>
                            </div>
                        </Hidden>
                        <div className={classes.Mform} ref={ref}>
                            <div className={classes.subtitle} style={ props.lang === 'zh' ? {fontWeight: 'bold'} : {}}>
                                {cfg('login.adminTitle')}
                            </div>
                            <div className={classes.member_input}>
                                <FieldWrapper >
                                    <QnectTextField
                                        field="adminEmailAddress"
                                        value={adminEmailAddress}
                                        errorMessage={adminEmailErrorMessage}
                                        onChange={e => {
                                            setAdminEmailAddress(e.target.value);
                                            setAdminEmailErrorMessage("");
                                        }}
                                        placeholder={ cfg('login.adminEmailAddressPlaceHolder') }
                                        formId={formId}
                                    />
                                </FieldWrapper>
                                <FieldWrapper>
                                    <QnectTextField
                                        className="passwordField"
                                        field="loginPassword"
                                        type="password"
                                        value={password}
                                        formId={formId}
                                        errorMessage={passwordErrorMessage}
                                        onChange={e => {
                                            setPassword(e.target.value);
                                            setPasswordErrorMessage('');
                                        }}
                                    />
                                </FieldWrapper>
                                <FieldWrapper >
                                    <QnectTextField
                                        field="clientLoginEmailAddress"
                                        className="passwordField"
                                        value={emailAddress}
                                        errorMessage={emailErrorMessage}
                                        onChange={e => {
                                            setEmailAddress(e.target.value);
                                            setEmailErrorMessage("");
                                        }}
                                        placeholder={ cfg('login.emailAddressPlaceHolder') }
                                        formId={formId}
                                    />
                                </FieldWrapper>
                                <FieldWrapper>
                                    <QnectButton
                                        field="continue"
                                        disabled={!emailAddress || !adminEmailAddress || !password || hasError || isPvtModeOn}
                                        onClick={handleLogin}
                                    />
                                </FieldWrapper>
                                {isPvtModeOn && (
                                    <FieldWrapper>
                                        <div className="Small">
                                            <span className="ErrorText">
                                                {cfg('pvtModeOn.label')}
                                            </span>
                                        </div>
                                    </FieldWrapper>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <VerificationCodeDialog
                open={verifyOpen}
                maskedEmail={adminEmailAddress}
                onClose={() => setVerifyOpen(false)}
                onConfirm={handleVerifyOtp}
                onOther={() => {
                    setVerifyOpen(false);
                }}
                value={otpValue}
                setValue={setOtpValue}
                errorMessage={otpErrorMessage}
                setOtpErrorMessage={setOtpErrorMessage}
                handleResend={handleResend}
                resendTimer={resendTimer}
                cfg={cfg}
                lang={props.lang}
            />

            <TooManyFailedAttemptsDialog
                open={failedOpen}
                onClose={() => setFailedOpen(false)}
                cfg={cfg}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        lang: _getLang(state),
        noLogin: _isNoLogin(state),
        showOtpModal: _getShowOtpModal(state),
        user: _getUser(state),
        policy: _getPolicy(state),
        systemAvailable: _getSystemAvailable(state),
        isPvtModeOn: _getIsPvtModeOn(state),
    }
}

const mapDispatchToProps = {
    setLang: _setLang,
    checkEmailIfRegistered: _checkEmailIfRegistered,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    clearToken: _clearToken,
    storePolicy: _storePolicy,
    setOtpToken: _setOtpToken,
    setCpToken: _setCpToken,
    verifyOtpAndGetUserDetail: _verifyOtpAndGetUserDetail,
    storeUser: _storeUser,
    showModal: _showModal,
    hideModal: _hideModal,
    setShowOtpModal: _setShowOtpModal,
    generatePortfolioToken: _generatePortfolioToken,
    setPortfolioToken: _setPortfolioToken,
    getUserDetailsFromToken: _getUserDetailsFromToken,
    resetPolicy: _resetPolicy,
    resetUser: _resetUser,
    verifyAdminUserCredentials: _verifyAdminUserCredentials,
    setAdminLogin: _setAdminLogin,
    setTimerStarted: _setTimerStarted,
    getScheduledMaintenance: _getScheduledMaintenance
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminLogin));
